import { PaymentMethodType, PreferredPaymentMethod, SupportedLocale } from '@afterpay/types'
import { IdentityCheckStatus } from '@afterpaytouch/portal-api'

export const isIdentityValid = (identity: IdentityCheckStatus | undefined): boolean =>
  identity === IdentityCheckStatus.VERIFIED || identity === IdentityCheckStatus.NOT_REQUIRED

export const hasPreferredPaymentMethod = (preferredPaymentMethod: PreferredPaymentMethod | PaymentMethodType | null | undefined): boolean =>
  preferredPaymentMethod !== null

// Shadow account uuids are the Cash customerToken; the "C_" prefix is enforced by Consumer.createNewShadowConsumer in pay-later.
export const isCashCohort = (uuid: string | undefined | null): boolean => uuid?.startsWith('C_') ?? false

// AU, NZ and UK require hard ID checks, also needs to chek feature flags
export const isHardIdVerificationRequiredLocale = (locale: SupportedLocale | undefined): boolean => {
  return locale === 'en-NZ' || locale === 'en-GB' || locale === 'en-AU'
}
